import React, { useContext, useEffect, useState } from "react";
import styles from "./Addresses.module.css";

import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import AuthContext from "../../store/AuthCtx";
import { api } from "../../api/api";

import Modal from "../../components/dashboard/addresses/BoxModal";
import DeleteConfirmationModal from "../../components/dashboard/addresses/DeleteModal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faEdit,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import CustomPagination from "../../components/common/CustomPagination";
import { ClipLoader } from "react-spinners";

const buttonStyle = (color) => {
  return {
    background: color,
    outline: "none",
    border: "none",
    padding: "5px",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
    fontWeight: "600",
    marginRight: "5px",
    fontSize: "16px",
  };
};

const customStyles = {
  headRow: {
    style: {
      border: "none",
    },
  },
  headCells: {
    style: {
      color: "white",
      backgroundColor: "#6f9be2",
      fontWeight: 600,
      fontSize: "16px",
    },
  },
  rows: {
    style: {
      borderBottomColor: "#FFFFFF",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#bfcfea",
      borderBottomColor: "#FFFFFF",
    },
  },
};

function Address() {
  const [openModal, setOpenModal] = useState(false);
  const [Address, setAddress] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [changed, setChanged] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  //Table Config
  const columns = [
    {
      name: "ID",
      selector: (row) => row.addressId,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Postal Code",
      selector: (row) => row.zip,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      width: "200px",
    },
    {
      name: "City",
      selector: (row) => row.city,
    },
    {
      name: "Province",
      selector: (row) => row.province,
    },
    {
      name: "Country",
      selector: (row) => row.country,
    },
    {
      cell: (row) => (
        <button
          onClick={() => editClickHandler(row._id)}
          style={buttonStyle("#6f9be2")}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
      allowOverflow: true,
      button: true,
      width: "34px",
    },
    {
      cell: (row) => (
        <button
          onClick={() => {
            setSelectedAddress(row._id);
            setDeleteModal(true);
          }}
          style={buttonStyle("red")}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      ),
      allowOverflow: true,
      button: true,
      width: "34px",
    },
  ];

  const AuthCtx = useContext(AuthContext);

  useEffect(() => {
    if (AuthCtx.userToken) {
      const getAddress = async () => {
        setLoading(true);
        try {
          const data = await api.get(
            `/address/getAddresses?page=${page}&search=${searchValue}`
          );
          setAddress(data.data.addresses);
          setTotalPages(data.data.totalPages);
        } catch (err) {
          // toast.error("Error Occured");
        } finally {
          setLoading(false);
        }
      };
      getAddress();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AuthCtx.isLoggedIn, changed, AuthCtx.userToken, page]);

  const addNewHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const name = e.target.name.value;
    const zip = e.target.zip.value;
    const address = e.target.address.value;
    const province = e.target.province.value;
    const city = e.target.city.value;
    const addressId = e.target.addressId.value;
    if (isEditing) {
      try {
        await api.put("/address/updateAddress", {
          id: selectedAddress,
          name: name,
          zip,
          address,
          province,
          city,
          addressId,
        });
        e.target.reset();
        setOpenModal(false);
        setIsEditing(false);
        setSelectedAddress(null);
        setIsLoading(false);
        toast.success("Update Successfully");
        setChanged((prev) => !prev);
      } catch (err) {
        toast.error("Something Went Wrong");
      }
    } else {
      try {
        await api.post("/address/createAddress", {
          name: name,
          zip,
          address,
          province,
          city,
          addressId,
        });
        e.target.reset();
        setOpenModal(false);
        toast.success("Added Successfully");
        setChanged((prev) => !prev);
      } catch (err) {
        toast.error("Something Went Wrong");
      }
    }
  };

  const deleteHandler = async () => {
    try {
      await api.delete(`/address/deleteAddress/${selectedAddress}`);
      setDeleteModal(false);
      setSelectedAddress(null);
      toast.success("Deleted");
      setChanged((prev) => !prev);
    } catch (err) {
      toast.error("Error Occurs");
    }
  };

  const editClickHandler = (id) => {
    setSelectedAddress(id);
    setIsEditing(true);
    setOpenModal(true);
  };

  const searchHandler = async (e) => {
    e.preventDefault();
    if (searchValue === "") {
      return;
    }
    setPage(1);
    setChanged((prev) => !prev);
  };

  return (
    <>
      {openModal && (
        <Modal
          isLoading={isLoading}
          isEditing={isEditing}
          onSubmit={addNewHandler}
          onClose={() => {
            setOpenModal(false);
            setSelectedAddress(null);
            setIsEditing(false);
          }}
          addressId={selectedAddress}
        />
      )}
      {deleteModal && (
        <DeleteConfirmationModal
          onClose={() => {
            setDeleteModal(false);
            setSelectedAddress(null);
          }}
          onDelete={deleteHandler}
        />
      )}
      <div className={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <button onClick={() => setOpenModal(true)} className={styles.button}>
            Add New Address
          </button>
          <form onSubmit={searchHandler} className={styles.search}>
            <input
              type="text"
              placeholder="Search Address By ID or Name"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <button>
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </form>
        </div>
        {!loading && Address.length === 0 && (
          <p className={styles.alert}>
            No Record. Please Add Address to continue
          </p>
        )}
        {!loading && Address.length > 0 && (
          <>
            <DataTable
              className={styles.table}
              columns={columns}
              data={Address}
              customStyles={customStyles}
              highlightOnHover
            />
            <CustomPagination
              pageCount={totalPages}
              handlePageClick={({ selected }) => setPage(selected + 1)}
              page={page}
            />
          </>
        )}
        {loading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              minHeight: "60vh",
              minWidth: "60vw",
            }}
          >
            <ClipLoader
              className={styles.loadingSpinner}
              loading={loading}
              color="#6f9be2"
              size={30}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Address;
